import {IAdditionalEmail, IMessengerChat} from '../model/INotifyChannel';

export const getMessengerChatLabel = (chat: IMessengerChat): string => chat.description ?? chat.chat;

export const getAdditionalEmailLabel = (email: IAdditionalEmail): string => email.description ?? email.email;
